"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.paddingProps = exports.marginProps = exports.bynderImageProps = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
/**
 * Vertical Spacing - Box Model Sizes
 *
 * @constant {Object.string[]}
 */

const marginProps = exports.marginProps = {
  verticalMargin: _propTypes.default.oneOf(['none', 'small', 'medium', 'large'])
};
const paddingProps = exports.paddingProps = {
  verticalPadding: _propTypes.default.oneOf(['none', 'small', 'medium', 'large'])
};
const bynderImageProps = exports.bynderImageProps = {
  height: _propTypes.default.number,
  width: _propTypes.default.number,
  altText: _propTypes.default.string,
  url: _propTypes.default.string
};